import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../context/NotificationContext';

export default function Notifications() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const {
    notifications,
    showPanel,
    setShowPanel,
    markAsRead,
    deleteNotification,
  } = useNotifications();

  if (!user || pathname === '/cart') return null;
  if (!showPanel) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 'calc(env(safe-area-inset-top, 0px) + 4.5rem)',
        right: 16,
        zIndex: 10000,
      }}
      className="w-80 bg-white rounded-lg shadow-xl max-h-96 overflow-y-auto dark:bg-gray-800 dark:text-gray-100"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="p-4 border-b dark:border-gray-700 flex items-center justify-between">
        <h3 className="font-bold text-lg text-amber-800 dark:text-amber-200">Notifications</h3>
        <button
          onClick={() => setShowPanel(false)}
          className="text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white text-2xl font-bold leading-none w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 transition cursor-pointer"
          aria-label="Close notifications"
          type="button"
        >
          ×
        </button>
      </div>
      <div className="divide-y">
        {notifications.length === 0 ? (
          <div className="p-4 text-gray-500 text-center">No notifications</div>
        ) : (
          notifications.map((notification) => (
            <div
              key={notification.user_notification_id}
              className={`p-4 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer ${
                !notification.read ? 'bg-amber-50 dark:bg-amber-900' : ''
              }`}
              onClick={() => !notification.read && markAsRead(notification.user_notification_id)}
            >
              <div className="flex justify-between items-start gap-2">
                <div className="flex-1">
                  <h4 className="font-semibold text-sm dark:text-gray-100">{notification.title}</h4>
                  <p className="text-xs text-gray-600 dark:text-gray-300 mt-1">{notification.message}</p>
                  <p className="text-xs text-amber-700 dark:text-amber-300 mt-1">
                    From: {notification.cafe_name}
                  </p>
                </div>
                <button
                  onClick={(e) => deleteNotification(notification.user_notification_id, e)}
                  className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-red-500 hover:bg-red-600 active:bg-red-700 text-white rounded-full transition-colors"
                  type="button"
                  aria-label="Delete notification"
                >
                  <span className="text-xs font-bold">×</span>
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
